import { createEvent, createStore, merge } from 'effector';
import { fxForwardMessage, fxSendMessage } from '../messages/messages.model';

export const $error = createStore<Error | null>(null);
export const clearError = createEvent();

/** Передавать все эффекты раздела */
export const errorOccured = merge([fxForwardMessage.fail, fxSendMessage.fail]);
